import React from 'react';
import { MarketScanConfig } from '../types';

interface GradientWavesProps {
  config: MarketScanConfig;
}

const WAVE_PATH =
  'M184 278.066C120.014 159.628 2.16667 288.066 -20 341.566V531.5H1341.5V124C1245.1 140 1232.33 280.4 1176 341.566C1119.67 402.733 1060.67 217.566 978 296.566C895.333 375.566 718.8 486.166 674 296.566C629.2 106.966 519 169.899 469.5 225.066C420 280.232 392 339 338 349C284 359 218 341 184 278.066Z';

export const GradientWaves: React.FC<GradientWavesProps> = ({ config }) => {
  return (
    <div
      className="ms-waves-container"
      style={{
        animationDuration: `${config.timing.introWavesDurationMs}ms`,
        animationDelay: `${config.timing.introWavesDelayMs}ms`,
      }}
    >
      <svg className="ms-wave-svg" viewBox="0 0 1344 456" fill="none" preserveAspectRatio="none">
        <defs>
          <linearGradient
            id="ms-wave-grad-base"
            x1="-20"
            y1="285"
            x2="906"
            y2="-344"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF00D4" stopOpacity="0.8" />
            <stop offset="1" stopColor="#00E0FF" stopOpacity="0.9" />
          </linearGradient>
        </defs>
        <path className="ms-wave-layer-1" d={WAVE_PATH} fill="url(#ms-wave-grad-base)" />
        <path className="ms-wave-layer-2" d={WAVE_PATH} fill="url(#ms-wave-grad-base)" />
        <path className="ms-wave-layer-3" d={WAVE_PATH} fill="url(#ms-wave-grad-base)" />
      </svg>
    </div>
  );
};
